import * as React from 'react'

import { PlusIcon, SquaresIntersectIcon, SquaresUniteIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/client/src/shared/components/shadcn-ui/dropdown-menu'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import {
  AndOrOperator,
  getOperatorDisplayText,
} from '~/client/src/shared/models/LogicOperation'

interface IProps {
  onSelect: (operation: AndOrOperator) => void
}

const OPERATIONS = [
  { type: AndOrOperator.OR, Icon: SquaresUniteIcon },
  { type: AndOrOperator.AND, Icon: SquaresIntersectIcon },
]

export default function PlusControl({ onSelect }: IProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            variant="ghost"
            size="icon-xs"
            aria-label={Localization.translator.add}
          />
        }
      >
        <PlusIcon />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {OPERATIONS.map(({ type, Icon }) => (
          <DropdownMenuItem key={type} onClick={() => onSelect(type)}>
            <Icon className="tw:text-muted-foreground" />
            {getOperatorDisplayText(type)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
